import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

export function EmailSetupCta() {
    return (
        <Link
            // @ts-expect-error
            as={RoutedLink}
            variant='button-primary'
            size='xlarge'
            to={{hash: '/connect-email/get-started'}}
        >
            Connect your email
        </Link>
    );
}
